export default __webpack_public_path__ + "static/media/bank-icon.ba31c930.png";